import { Component, OnInit, AfterViewInit, OnDestroy, Input, ViewChild, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { ReportsService } from "../reports.service";
import { SortModel } from "../../shared/sort.model";
import { RevenueReportSortField } from "./revenue-report-sort.enum";
import { PageSizeSelectionComponent } from "../../shared/page-size-selection.component";
import { DropdownValue } from "../../shared/dropdown.model";
import { IRevenueReportViewModel } from "./revenue-report.model";
import { EndpointsService } from "../../core/services/index";
import { Response } from "@angular/http";
import { FileSaverService } from "../../shared/file-saver.servive";
import { CustomHorizontalScrollService } from "../../shared/custom-horizontal-scroll.service";
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';
import { SortService } from '../../shared/sort.service';

@Component({
    moduleId: module.id,
    selector: 'revenue-report',
    templateUrl: 'revenue-report.component.html'
})

export class RevenueReportComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() fileName: string;
    data: IRevenueReportViewModel[];
    showOverlay: boolean = true;
    pageNumber: number = 1;
    totalCount: number;
    pageSize: number = 0;
    publisherSort: SortModel = new SortModel(RevenueReportSortField.Publisher, SortModel.disabledIcon);
    countrySort: SortModel = new SortModel(RevenueReportSortField.Country, SortModel.disabledIcon);
    completesSort: SortModel = new SortModel(RevenueReportSortField.Completes, SortModel.disabledIcon);
    earningsSort: SortModel = new SortModel(RevenueReportSortField.Revenue, SortModel.descIcon);
    rpeSort: SortModel = new SortModel(RevenueReportSortField.RPE, SortModel.disabledIcon);
    useLightClass: boolean = true;
    private sortDirectionAsc: boolean = false;
    private sortField: SortModel;
    private inXhrGetRevenueReports: any;
    disableCsvButton: boolean = false;
    disableExcelButton: boolean = false;

    @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent

    constructor(
        private reportsService: ReportsService,
        private fileSaverService: FileSaverService,
        private scrollService: CustomHorizontalScrollService,
        private sortService: SortService) {
    }

    ngOnInit(): void {
        this.sortField = this.earningsSort;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.data)
            this.getRevenueReports(1);
    }

    ngOnDestroy(): void {
        if (this.inXhrGetRevenueReports) {
            this.inXhrGetRevenueReports.unsubscribe();
        }
        this.scrollService.toggleHorizontalScroll(false);
    }
    
    ngAfterViewInit(): void {
        this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
        this.getRevenueReports(1);
    }

    onResize(event) {
        this.toggleHorizontalScroll();
    }
    
    private toggleHorizontalScroll() {
        let self = this;
        setTimeout(function() {
            self.scrollService.toggleHorizontalScroll();            
        }, 10);
    }

    onPageSizeChanged(item: DropdownValue) {
        this.pageSize = item.value;
        this.pageNumber = 1;
        this.getRevenueReports(this.pageNumber);
    }

    onSortChanged(sort: SortModel) {
        let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
        this.sortField = sortResult.existingSortModel;
        sort = sortResult.selectedSortModel;
        this.sortDirectionAsc = sortResult.sortDiresctionAsc;

        this.getRevenueReports(1);
    }

    downloadCsv(event: any) {
        event.preventDefault();
        this.disableCsvButton = true;
        let fileName = `${this.fileName} Revenue`;
        let file = `${fileName}.csv`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.Revenue, FileType.Csv).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableCsvButton = false; }
        )
    }

    downloadExcel(event: any) {
        event.preventDefault();
        this.disableExcelButton = true;
        let fileName = `${this.fileName} Revenue`;
        let file = `${fileName}.xlsx`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.Revenue, FileType.Excel).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableExcelButton = false; }
        )
    }

    public getRevenueReports(page: number): void {
        if (this.inXhrGetRevenueReports) {
            this.inXhrGetRevenueReports.unsubscribe();
        }
        this.showOverlay = true;
        this.inXhrGetRevenueReports = this.reportsService.getRevenueReports(this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.startDate, this.endDate)
            .subscribe((res: any) => {
                this.data = <IRevenueReportViewModel[]>res.json().data;
                this.totalCount = res.json().total;
                this.pageNumber = page;
            },
            () => { },
            () => { this.showOverlay = false; this.toggleHorizontalScroll(); }
            )
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/revenue-report/revenue-report.component.ts